export const COACHMARK_POST_PAGE = "hasSeenCoachmarkPostPage";
export const COACHMARK_CREATOR_PAGE = "hasSeenCoachmarkCreatorPage";
export const COACHMARK_SHARE_FOLLOWS = "hasSeenCoachmarkShareFollows";
export const CONTENT_DISPLAY_SHOPPER_INTERVIEW = "hasSeenShopperInterview";
export const BRANCH_JOURNEY_DISMISSALS = "BRANCH_WEBSDK_KEYjourneyDismissals";
